import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-20e19721"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  id: "dashboard",
  class: "view"
}
const _hoisted_2 = { class: "container mobile-menu" }
const _hoisted_3 = { class: "box" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-calendar",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-bar-chart",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-map-o",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-trophy",
  "aria-hidden": "true"
}, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = { class: "container" }
const _hoisted_13 = { class: "container dashboard-container" }
const _hoisted_14 = { class: "left-container dashboard-sub-container" }
const _hoisted_15 = { class: "right-container dashboard-sub-container" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { id: "bottom" }, null, -1))
const _hoisted_17 = {
  key: 1,
  class: "app-loading"
}

import { ComputedRef, Ref, computed, ref } from 'vue'

  import Timeline from '@/components/Dashboard/Timeline.vue'
  import UserCalendar from '@/components/Dashboard/UserCalendar/index.vue'
  import UserMonthStats from '@/components/Dashboard/UserMonthStats.vue'
  import UserRecords from '@/components/Dashboard/UserRecords/index.vue'
  import UserStatsCards from '@/components/Dashboard/UserStatsCards/index.vue'
  import { AUTH_USER_STORE, SPORTS_STORE } from '@/store/constants'
  import { ISport } from '@/types/sports'
  import { IAuthUserProfile } from '@/types/user'
  import { useStore } from '@/use/useStore'

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const store = useStore()

  const authUser: ComputedRef<IAuthUserProfile> = computed(
    () => store.getters[AUTH_USER_STORE.GETTERS.AUTH_USER_PROFILE]
  )
  const sports: ComputedRef<ISport[]> = computed(
    () => store.getters[SPORTS_STORE.GETTERS.SPORTS]
  )
  const isSelected: Ref<string> = ref('calendar')

  function updateDisplayColumn(target: string) {
    isSelected.value = target
  }

return (_ctx: any,_cache: any) => {
  const _component_Loader = _resolveComponent("Loader")!

  return (_unref(authUser).username && _unref(sports).length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["mobile-menu-item", { 'is-selected': isSelected.value === 'calendar' }]),
              onClick: _cache[0] || (_cache[0] = ($event: any) => (updateDisplayColumn('calendar')))
            }, _hoisted_5, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["mobile-menu-item", { 'is-selected': isSelected.value === 'chart' }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (updateDisplayColumn('chart')))
            }, _hoisted_7, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["mobile-menu-item", { 'is-selected': isSelected.value === 'timeline' }]),
              onClick: _cache[2] || (_cache[2] = ($event: any) => (updateDisplayColumn('timeline')))
            }, _hoisted_9, 2),
            _createElementVNode("div", {
              class: _normalizeClass(["mobile-menu-item", { 'is-selected': isSelected.value === 'records' }]),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (updateDisplayColumn('records')))
            }, _hoisted_11, 2)
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createVNode(UserStatsCards, { user: _unref(authUser) }, null, 8, ["user"])
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createVNode(UserMonthStats, {
              sports: _unref(sports),
              user: _unref(authUser),
              class: _normalizeClass({ 'is-hidden': !(isSelected.value === 'chart') })
            }, null, 8, ["sports", "user", "class"]),
            _createVNode(UserRecords, {
              sports: _unref(sports),
              user: _unref(authUser),
              class: _normalizeClass({ 'is-hidden': !(isSelected.value === 'records') })
            }, null, 8, ["sports", "user", "class"])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createVNode(UserCalendar, {
              sports: _unref(sports),
              user: _unref(authUser),
              class: _normalizeClass({ 'is-hidden': !(isSelected.value === 'calendar') })
            }, null, 8, ["sports", "user", "class"]),
            _createVNode(Timeline, {
              sports: _unref(sports),
              user: _unref(authUser),
              class: _normalizeClass({ 'is-hidden': !(isSelected.value === 'timeline') })
            }, null, 8, ["sports", "user", "class"])
          ])
        ]),
        _hoisted_16
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
        _createVNode(_component_Loader)
      ]))
}
}

})